export const CREATE_ORDER_WIZARD_NAMESPACE = 'create-order';

export enum CREATE_ORDER_STEPS {
  CARD_TYPE_SELECTION = 'CARD_TYPE_SELECTION',
  ORDER_EMPLOYEES_SELECTION = 'EMPLOYEES_SELECTION',
  RE_ORDER_EMPLOYEES_SELECTION = 'RE_ORDER_EMPLOYEES_SELECTION',
  ORDER_RECAP = 'ORDER_RECAP',
}
